<template>
  <div id="app">
    <div class="index_header">
      <div class="header_img">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="header_name">
        <div class="name_title">宁夏亘利建筑工程有限公司</div>
        <div class="name_english">
          Ningxia Genli Construction Engineering Co., Ltd.
        </div>
      </div>
      <div class="header_phone"> 质量为先 服务为本</div>
      <div class="header_search">
        <el-input placeholder="请输入搜索内容" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="index_menu">
      <div class="menu_item" :style="{}" v-for="(item, i) in menuList" :key="i" @click="handleMenu(item, i)">
        <div class="menu_title">{{ item.name }}</div>
        <div class="menu_en">{{ item.en }}</div>
      </div>
    </div>
    <router-view />
    <div class="home_bottom_bg">
      <div class="bottom_menu">
        <div class="bottom_menu_item" v-for="(item, i) in menuList" :key="i" :style="{
          borderRight: i !== menuList.length - 1 ? '1px solid #fff' : '',
        }" v-if="i !== 0" @click="handleMenu(item, i)">
          {{ item.name }}
        </div>
      </div>
      <div class="copyright">
        Copyright © 2018-2020 All Rights Reserved. 版权所有：{{
          infoJson.companyInfo.name
        }}
        {{ infoJson.companyInfo.icp }}
      </div>
    </div>
  </div>
</template>
<script>
import infoJson from "@/utils/info.json";
export default {
  data() {
    return {
      infoJson,
      input3: "",
      menuI: 0,
      menuList: [
        { url: "/", name: "首页", en: "Home" },
        { url: "/aboutUs", name: "关于亘利", en: "About us" },
        { url: "/news", name: "新闻资讯", en: "News" },
        { url: "/businessScope", name: "经营项目", en: "Business Scope" },
        { url: "/engineeringCase", name: "工程案例", en: "Project Cases" },
        { url: "/contactUs", name: "联系我们", en: "Contact Us" },
      ],
    };
  },
  methods: {
    handleMenu(row, i) {
      if (this.$route.path === row.url) {
        return
      }
      this.menuI = i;
      this.$router.push({ path: row.url });
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "ysbth";
  src: url("@/assets/font/ysbth.ttf") format("truetype");
  /* 添加其他字体格式，如woff2等 */
}

body {
  margin: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  /*滚动条整体样式*/
}

#app {
  width: 100vw;
  height: 100vh;

  .home_bottom_bg {
    height: 100px;
    width: 100%;
    background-color: rgba(97, 149, 51, 0.6);
    padding: 0 15%;

    .copyright {
      width: 100%;
      margin-top: 10px;
      color: rgba(0, 0, 0, 0.6);
    }

    .bottom_menu {
      display: flex;
      color: #fff;
      margin-left: -25px;
      padding-top: 20px;

      .bottom_menu_item {
        width: 120px;
        text-align: center;
        cursor: pointer;

        &:hover {
          color: rgba(97, 149, 51, 1);
        }
      }
    }
  }

  .index_menu {
    height: 80px;
    width: 100vw;
    background: rgba(97, 149, 51, 0.6);
    display: flex;
    justify-content: center;

    .menu_item {
      width: 200px;
      position: relative;

      .menu_title {
        line-height: 60px;
        height: 80px;
        text-align: center;
        font-size: 20px;
        font-family: "ysbth", sans-serif;
        letter-spacing: 1px;
        color: #fff;
      }

      .menu_en {
        position: absolute;
        text-align: center;
        font-size: 12px;
        color: #fff;
        left: 50%;
        transform: translateX(-50%);
        top: 55%;
      }

      cursor: pointer;

      &:hover {
        background: rgba(97, 149, 51, 0.8);

        .menu_title {
          color: #ddeefe;
        }

        .menu_en {
          color: #ddeefe;
        }
      }
    }
  }

  .index_header {
    height: 140px;
    width: 100vw;
    background: #ddeefe;
    font-family: "ysbth", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;

    .header_search {
      margin-left: 40px;
    }

    .header_phone {
      margin: 0 20px;
      height: 30px;
      line-height: 30px;
      color: #009fa1;
      font-size: 26px;
      font-style: italic;
      text-align: center;
    }

    .header_name {
      .name_title {
        color: #619533;
        font-size: 50px;
        line-height: 50px;
      }

      .name_english {
        color: #619533;
        font-size: 20px;
        line-height: 20px;
      }
    }

    .header_img {
      margin-right: 20px;
      margin-top: -10px;

      img {
        width: 150px;
        height: 150px;
      }
    }
  }
}
</style>
